export const privacySections = [
  {
    title: 'What data we collect',
    body: [
      'When you place an order, we collect your name and phone number. We use local storage in your browser to save your cart so you can continue shopping later. We do not collect personal data beyond what you provide when ordering.',
    ],
  },
  {
    title: 'Why we collect it',
    body: [
      'Your name and phone number are used to process orders and contact you about your purchase. Cart data in local storage helps us improve your visit by remembering your selections between sessions.',
    ],
  },
  {
    title: 'How long we keep it',
    body: [
      'Order details are retained as needed for business and legal purposes. Cart data in local storage remains in your browser until you clear it or until you dismiss our storage disclosure (we may remind you about it periodically).',
    ],
  },
  {
    title: 'Who we share with',
    body: [
      'We use Firebase (Google) for our product database and hosting. Order information may be shared via WhatsApp when you submit an order. We do not sell your data to third parties.',
    ],
  },
  {
    title: 'Your rights',
    body: [
      'You can clear your browser\'s local storage at any time to remove cart data. You may contact us to ask about or request changes to your order information.',
    ],
  },
];
